import * as React from "react";
export default class Footer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("footer", { className: "footer-C" }, "Powered by Liquor Connect"));
    }
}
;
//# sourceMappingURL=footer.js.map